import { select } from '@js/util/select.js'
import $ from 'jquery'
import Swiper from 'swiper'
import { Pagination, Autoplay, Keyboard } from 'swiper/modules'

select('.slider-integrated .swiper', element => {
  /*******************************
   * Swiper Initialization
   ******************************/

  let swiper = new Swiper(element, {
    modules: [Pagination, Autoplay, Keyboard],
    autoHeight: true,
    // TODO: check lazy load mechanism
    lazy: {
      loadOnTransitionStart: false,
      loadPrevNext: true,
    },
    on: {
      slideChange: function (swiper) {
        swiper.slides.forEach(function (slide) {
          const background = slide.getAttribute('data-background')
          if (background && !slide.style.backgroundImage) {
            slide.style.backgroundImage = `url(${background})`
          }
        })
      },
    },
    ...$(element).data('options'),
  })

  $(element)
    .find('.swiper-button-next')
    .on('click', function () {
      swiper.slideNext()
    })

  $(element)
    .find('.swiper-button-prev')
    .on('click', function () {
      swiper.slidePrev()
    })
})
